import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../assets/css/index.css";

const Landing = () => {
  const [popupData, setPopupData] = useState({
    title: "",
    image: "",
    description: "",
    show: false,
  });

  const openPopup = (title, image, description) => {
    setPopupData({ title, image, description, show: true });
  };

  const closePopup = () => {
    setPopupData({ ...popupData, show: false });
  };

  return (
    <div className="presentation-container">
      <div id="splash-screen">
        <img src="/assets/img/logo.png" alt="RusticoPlay Logo" className="splash-logo" />
      </div>

      <div className="video-container">
        <video autoPlay muted loop id="bgVideo">
          <source src="/videos/intro.mp4" type="video/mp4" />
        </video>
      </div>

      <nav className="navbar">
        <img src="/assets/img/logo.png" alt="RusticoPlay Logo" className="logo" />
        <Link to="/login" className="btn-login">Entrar</Link>
      </nav>

      <div className="hero-section">
        <h1>O Melhor do Sertanejo em um só lugar</h1>
        <p>Shows exclusivos, filmes, documentários e muito mais. Tudo para você se emocionar com a música que é a cara do Brasil.</p>
        <div className="cta-buttons">
          <Link to="/signup" className="cta-button">Comece agora</Link>
          <Link to="/login" className="cta-button secondary">Entrar</Link>
        </div>
      </div>

      <div className="highlights-section">
        <h2>Conteúdos Exclusivos</h2>

        {[
          {
            title: "Shows",
            items: [
              ["Zezé Di Camargo & Luciano", "/assets/img/zeze&luciano.jpg", "Show exclusivo da dupla sertaneja que marcou gerações."],
              ["Edson & Hudson", "/assets/img/edson_hudson.png", "Ao vivo em Jaguariúna, um show emocionante."],
              ["Chitãozinho & Xororó", "/assets/img/chitaozinho-e-xororo.jpg", "Turnê comemorativa de 50 anos de carreira."]
            ]
          },
          {
            title: "Filmes",
            items: [
              ["2 Filhos de Francisco", "/assets/img/2_Filhos_de_Francisco.jpg", "A emocionante história da dupla Zezé Di Camargo & Luciano."],
              ["O Menino da Porteira", "/assets/img/menino_da_porteira.jpg", "Um clássico do cinema sertanejo."],
              ["É o Amor", "/assets/img/e_o_amor.jpg", "Uma história de superação e amor no sertão."]
            ]
          },
          {
            title: "Documentários",
            items: [
              ["A História do Sertanejo", "/assets/img/doc1.jpg", "Conheça a trajetória da música sertaneja no Brasil."],
              ["Vida no Campo", "/assets/img/doc2.jpg", "A realidade da vida no interior e suas histórias."],
              ["Festa de Peão", "/assets/img/doc3.jpg", "Os bastidores das maiores festas de peão do país."]
            ]
          },
          {
            title: "Entrevistas",
            items: [
              ["Zezé Di Camargo", "/assets/img/entrevista1.jpg", "Entrevista exclusiva com Zezé Di Camargo."],
              ["Marília Mendonça", "/assets/img/entrevista2.jpg", "Conversa íntima com a rainha da sofrência."],
              ["Jorge & Mateus", "/assets/img/entrevista3.jpg", "A dupla conta sobre sua trajetória e sucessos."]
            ]
          }
        ].map((category, index) => (
          <div className="category" key={index}>
            <h3>{category.title}</h3>
            <div className="carousel">
              {category.items.map(([title, image, description], idx) => (
                <div className="carousel-item" key={idx} onClick={() => openPopup(title, image, description)}>
                  <img src={image} alt={title} />
                  <p>{title}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="discover-more-section">
        <div className="discover-content">
          <h2>Descubra um mundo de emoções sertanejas</h2>
          <p>Além do que você viu, temos centenas de conteúdos exclusivos que são atualizados semanalmente.</p>
          <Link to="/signup" className="cta-button">Explorar o catálogo completo</Link>
        </div>
        <div className="discover-image">
          <span className="material-symbols-outlined">auto_awesome</span>
        </div>
      </div>

      {popupData.show && (
        <div className="popup">
          <div className="popup-content">
            <span className="close-btn" onClick={closePopup}>&times;</span>
            <img id="popup-image" src={popupData.image} alt="Imagem do conteúdo" />
            <h2 id="popup-title">{popupData.title}</h2>
            <p id="popup-description">{popupData.description}</p>
            <Link to="/signup" className="cta-button">Vamos começar</Link>
          </div>
        </div>
      )}

      <div className="benefits-section">
        <h2>Por que escolher o RusticoPlay?</h2>
        <div className="benefits-container">
          <div className="benefit-card">
            <span className="material-symbols-outlined">live_tv</span>
            <h3>Shows Exclusivos</h3>
            <p>Acesso a shows que você só encontra aqui.</p>
          </div>
          <div className="benefit-card">
            <span className="material-symbols-outlined">movie</span>
            <h3>Filmes e Documentários</h3>
            <p>Histórias emocionantes sobre o universo sertanejo.</p>
          </div>
          <div className="benefit-card">
            <span className="material-symbols-outlined">headphones</span>
            <h3>Qualidade Imbatível</h3>
            <p>Áudio e vídeo de alta qualidade para você curtir.</p>
          </div>
        </div>
      </div>

      <footer className="footer">
        <p>&copy; 2025 RusticoPlay. Todos os direitos reservados.</p>
      </footer>
    </div>
  );
};

export default Landing;
